import { render } from "./CheckManagementUpdate.vue?vue&type=template&id=56a474c8&scoped=true"
import script from "./CheckManagementUpdate.vue?vue&type=script&lang=js"
export * from "./CheckManagementUpdate.vue?vue&type=script&lang=js"

import "./CheckManagementUpdate.vue?vue&type=style&index=0&id=56a474c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a474c8"]])

export default __exports__